// extracted by css-extract-rspack-plugin
export default {"panel":"GeneralTabPanel_panel__DnCHL"};